import { Resource } from 'graphql/types.generated';
import Type from './Resource.type';

export const selectResource = ({ resourceId }: { resourceId: string }) => {
  return {
    type: Type.SELECT_RESOURCE,
    payload: { resourceId },
  };
};
